export const setErrorMessage = (message) => ({
  type: 'SET_ERROR_MESSAGE',
  message,
});

export const resetErrorMessage = () => ({
  type: 'RESET_ERROR_MESSAGE',
});

export const setApplicationReady = () => ({
  type: 'SET_APPLICATION_READY',
});

export const setSideMenuCollapsed = () => ({
  type: 'SET_SIDE_MENU_COLLAPSED',
});
